import React from 'react';
import { Modal } from './Modal';
import { CartQuery } from 'lib/api';
import Testimonial from './Testimonial';
import { tw } from 'twind';

interface ModalAgeRestrictionProps {
  open: boolean;
  onClose: () => void;
  underAge: () => void;
  cart: CartQuery['Cart'];
}

export const ModalAgeRestriction: React.FC<ModalAgeRestrictionProps> = ({ open, onClose, cart, underAge }) => {
  return (
    <Modal open={open} requestClose={underAge}>
      <div>
        <div className={tw`flex items-center justify-center pt-8`}>
          <img src={cart.shop?.avatar} alt={cart.shop?.display_name ?? ''} style={{ maxWidth: 80, height: 'auto' }} />
        </div>

        {cart.testimonial && <Testimonial quote={cart.testimonial} />}

        <h1 className={tw`text-[30px] text-center text-black font-bold pt-4 pb-6`}>Are you +21?</h1>

        <div className={tw`flex items-center justify-center gap-[10px] w-full`}>
          <button
            className={tw`rounded-[4px] px-6 py-3 text-sm leading-4 font-bold bg-[grey] text-white disabled:cursor-not-allowed focus:outline-none focus:ring-offset-2 focus:ring-white-500 disabled:opacity-60 text-center`}
            onClick={underAge}
          >
            No
          </button>

          <button
            className={tw`rounded-[4px] px-6 py-3 text-sm leading-4 font-bold bg-[#20204b] text-white disabled:cursor-not-allowed focus:outline-none focus:ring-offset-2 focus:ring-white-500 disabled:opacity-60 text-center`}
            onClick={onClose}
          >
            Yes
          </button>
        </div>
      </div>
    </Modal>
  );
};
